import { defineCapability } from './internal';
import { args } from '../common/args';
export const ADD_TO_BOOKMARKS_CAP = defineCapability({
  name: 'ADD_TO_BOOKMARKS_CAP',
  args: {
    path: args.string(),
    id: args.string()
  }
});